export type RRDepartmentType = typeof RRDEPARTMENT_MONTAGE | typeof RRDEPARTMENT_CETARING | typeof RRDEPARTMENT_WAREHOUSE | typeof RRDEPARTMENT_STORE | typeof RRDEPARTMENT_NOTSET | typeof RRDEPARTMENT_LOGISTICS;

export const RRDEPARTMENT_NOTSET = "";
export const RRDEPARTMENT_MONTAGE = "MONTAGE";
export const RRDEPARTMENT_WAREHOUSE = "WAREHOUSE";
export const RRDEPARTMENT_CETARING = "CETARING";
export const RRDEPARTMENT_STORE = "STORE";
export const RRDEPARTMENT_LOGISTICS = "LOGISTICS";

export const RRDEPARTMENT_NOTSET_LABEL = "НЕ Е ЗАДАДЕН";
export const RRDEPARTMENT_MONTAGE_LABEL = "МОНТАЖ";
export const RRDEPARTMENT_WAREHOUSE_LABEL = "КУХНЯ";
export const RRDEPARTMENT_CETARING_LABEL = "КЕТЪРИНГ";
export const RRDEPARTMENT_STORE_LABEL = "КУХНЯ";
export const RRDEPARTMENT_LOGISTICS_LABEL = "ТРАНСПОРТ";

export function departmentAsString(department: RRDepartmentType) {
    if (department === RRDEPARTMENT_MONTAGE) {
        return RRDEPARTMENT_MONTAGE_LABEL;
    }
    if (department === RRDEPARTMENT_CETARING) {
        return RRDEPARTMENT_CETARING_LABEL;
    }
    if (department === RRDEPARTMENT_WAREHOUSE) {
        return RRDEPARTMENT_WAREHOUSE_LABEL;
    }
    if (department === RRDEPARTMENT_LOGISTICS) {
        return RRDEPARTMENT_LOGISTICS_LABEL;
    }
    return "";
}

export function stringAsDepartment(department: string): RRDepartmentType {
    const departmentUpper = department.toUpperCase();
    if (departmentUpper === "MONTAGE") {
        return RRDEPARTMENT_MONTAGE;
    }
    if (departmentUpper === "CATERING") {
        return RRDEPARTMENT_CETARING;
    }
    if (departmentUpper === "STORE") {
        return RRDEPARTMENT_WAREHOUSE;
    }
    if (departmentUpper === "LOGISTICS") {
        return RRDEPARTMENT_LOGISTICS;
    }
    return RRDEPARTMENT_NOTSET;
}
